// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__oajr\\+ {
  padding: 16px;
  display: flex;
  gap: 24px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
}
@media (max-width: 768px) {
  .styles_wrapper__oajr\\+ {
    background: none;
  }
}

.styles_cardWrapper__YXaXI {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.styles_textWrapper__7nOXv {
  display: flex;
  align-items: center;
  gap: 4px;
}
@media (max-width: 576px) {
  .styles_textWrapper__7nOXv {
    flex-direction: column;
    align-items: flex-start;
  }
}

.styles_headingWrapper__avgbu {
  margin-left: 16px;
}

.styles_heading__KVnbP,
.styles_measure__74Lm\\+ {
  font-weight: 300;
  line-height: 15px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.5);
}

.styles_heading__KVnbP {
  font-size: 12px;
}

.styles_measure__74Lm\\+ {
  font-size: 14px;
}

.styles_textWhite__mqqux {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  color: #ffffff;
}
@media (max-width: 1200px) {
  .styles_textWhite__mqqux {
    font-size: 14px;
    line-height: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Stake/content/calculatorBlock/cardList/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,aAAA;EACA,SAAA;EACA,8BCUS;EDTT,mBAAA;AAFF;AEyBE;EF5BF;IAQI,gBAAA;EADF;AACF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADF;AEaE;EFfF;IAMI,sBAAA;IACA,uBAAA;EAAF;AACF;;AAGA;EACE,iBAAA;AAAF;;AAGA;;EAEE,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BCrCS;ADqCX;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cC3DM;AD2DR;AExCE;EFmCF;IAQI,eAAA;IACA,iBAAA;EACF;AACF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  padding: 16px;\n  display: flex;\n  gap: 24px;\n  background: $black-30;\n  border-radius: 12px;\n\n  @include md {\n    background: none;\n  }\n}\n\n.cardWrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.textWrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  @include sm {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.headingWrapper {\n  margin-left: 16px;\n}\n\n.heading,\n.measure {\n  font-weight: 300;\n  line-height: 15px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-50;\n}\n\n.heading {\n  font-size: 12px;\n}\n\n.measure {\n  font-size: 14px;\n}\n\n.textWhite {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  color: $white;\n\n  @include xl {\n    font-size: 14px;\n    line-height: 18px;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__oajr+`,
	"cardWrapper": `styles_cardWrapper__YXaXI`,
	"textWrapper": `styles_textWrapper__7nOXv`,
	"headingWrapper": `styles_headingWrapper__avgbu`,
	"heading": `styles_heading__KVnbP`,
	"measure": `styles_measure__74Lm+`,
	"textWhite": `styles_textWhite__mqqux`
};
export default ___CSS_LOADER_EXPORT___;
